// Portado de src/pages/tratamentos/index.astro (site Astro).
import { CardsAtendimento } from "@/components/itv/CardsAtendimento";
import { CardsCapa } from "@/components/itv/tratamento/CardsCapa";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

// Os 6 grupos, com as mesmas fotos e badges da home.
const grupos = [
  { img: "/img/trat-1-420.webp", srcSet: "/img/trat-1-420.webp 420w, /img/trat-1-840.webp 840w", badge: "Emagrecimento", titulo: "Emagrecimento e saúde metabólica", texto: "Emagrecer com acompanhamento médico, preservando massa muscular.", href: "/tratamentos/emagrecimento/" },
  { img: "/img/trat-2-420.webp", srcSet: "/img/trat-2-420.webp 420w, /img/trat-2-840.webp 840w", badge: "Saúde hormonal", titulo: "Saúde hormonal", texto: "Investigar antes de repor: masculina, feminina e implante hormonal.", href: "/tratamentos/saude-hormonal/" },
  { img: "/img/trat-3.webp", badge: "Massa muscular", titulo: "Massa muscular e sarcopenia", texto: "Para quem está perdendo músculo, ou não consegue ganhar.", href: "/tratamentos/massa-muscular/" },
  { img: "/img/trat-4.webp", badge: "Medicina do esporte", titulo: "Medicina do esporte", texto: "Performance, recuperação e as dores de quem treina.", href: "/tratamentos/medicina-do-esporte/" },
  { img: "/img/trat-5.webp", badge: "Longevidade", titulo: "Longevidade e qualidade de vida", texto: "Energia e disposição de hoje, saúde e autonomia no longo prazo.", href: "/tratamentos/longevidade/" },
  { img: "/img/trat-6.webp", badge: "Estética", titulo: "Estética e medicina regenerativa", texto: "Flacidez, gordura localizada e cuidados capilares, com Unyque Pro e Mesoject Gun.", href: "/tratamentos/estetica-regenerativa/" },
];

export function TratamentosIndex() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-tratamentos-index">
      <section className="hero">
        <div className="container hero-inner">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span> <span>Tratamentos</span>
          </nav>
          <p className="hero-sobretitulo">TRATAMENTOS</p>
          <h1>
            Um cuidado para <em>cada objetivo.</em>
          </h1>
          <p className="hero-chamada">
            Seis grupos de cuidado, todos partindo da mesma base: avaliação completa, plano individual e
            acompanhamento de perto.
          </p>
        </div>
      </section>

      {/* porta de entrada: a Avaliação 360° abre a lista */}
      <section className="porta">
        <div className="container">
          <a className="porta-card" href="/tratamentos/avaliacao-360/">
            <div className="porta-texto">
              <p className="sobretitulo">POR ONDE COMEÇA</p>
              <h2>Avaliação 360°</h2>
              <p>
                A consulta que percorre os sete pilares, com bioimpedância inclusa. É a porta de entrada
                do consultório, seja qual for o tratamento depois.
              </p>
              <span className="porta-link">Conhecer a Avaliação 360° →</span>
            </div>
          </a>
        </div>
      </section>

      <CardsCapa sobretitulo="AS SEIS FRENTES" titulo="Escolha por onde o seu caso pede" cards={grupos} />

      <section className="cta">
        <div className="container cta-inner">
          <p className="cta-eyebrow">COMO FUNCIONA O ATENDIMENTO</p>
          <h2>
            Na dúvida sobre qual frente é a sua,
            <br />
            comece pela avaliação.
          </h2>
          <CardsAtendimento />
          <a className="btn-ouro cta-btn" href={agendar}>
            Agendar avaliação
          </a>
        </div>
      </section>
    </div>
  );
}
